"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var styled_components_1 = require("styled-components");
var recompose_1 = require("recompose");
var StyledFormSectionBase_1 = require("./StyledFormSectionBase");
var FormSectionBase = function (props) {
    var summary = props.summary, theme = props.theme;
    var backgroundColor = theme ? theme.global.colors[summary ? 'grey-1' : 'white'] : '';
    return (react_1.default.createElement(StyledFormSectionBase_1.StyledFormSectionBase, { backgroundColor: backgroundColor, summary: summary ? 1 : undefined, className: "FormSectionBase" }, props.children));
};
var FormSectionBaseWrapper = recompose_1.compose(styled_components_1.withTheme)(FormSectionBase);
exports.FormSectionBase = FormSectionBaseWrapper;
//# sourceMappingURL=FormSectionBase.js.map